import { CommonModule } from "@angular/common";
import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { ActivatedRoute, ParamMap, Router, RouterLink } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { TOKEN } from "@shared/constants/localstorage.constants";
import { ACCUEIL, PAYMENT_REQUEST } from "@shared/constants/route.constants";
import { ReceiptDetail } from "@shared/models/payment";
import { PaymentService } from "@shared/services/payment.service";
import { Guid } from "guid-typescript";
import { DateTime } from "luxon";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { DividerModule } from "primeng/divider";
import { PaymentFormComponent } from "./payment-form/payment-form.component";
import { PopupEventsPaymentComponent } from "./popup-events-payment/popup-events-payment.component";

@Component({
  selector: "app-regularisation-schedule",
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    RouterLink,
    CardModule,
    DividerModule,
    PaymentFormComponent,
    PopupEventsPaymentComponent,
    TranslateModule,
  ],
  templateUrl: "./regularisation-schedule.component.html",
  styleUrl: "./regularisation-schedule.component.scss",
})
export class RegularisationScheduleComponent implements OnInit {
  hasToken = false;
  paymentSuccess!: boolean;
  showPopupPayment!: boolean;

  suspensionDate!: Date;
  terminationDate!: Date;
  name = "";
  productName = "";
  numeroContrat = "";
  amount = 0;
  receiptDetails: ReceiptDetail[] = [];
  feeAmount = 0;
  formToken = "";
  userEmail = "";
  firstConnectionUrl = "";
  hasUnpaidReceipts = false;

  BACKBUTTON = "/" + ACCUEIL;

  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly route: ActivatedRoute,
    private readonly paymentService: PaymentService,
    private readonly router: Router
  ) {}

  ngOnInit() {
    this.hasToken = !!localStorage.getItem(TOKEN);
    this.route.queryParamMap.subscribe((params: ParamMap) =>
      this.paymentService.getSummaryPayment(Guid.parse(params.get("policy")!)).subscribe(data => {
        if (!data.debtDetails.hasUnpaidReceipts) {
          this.router.navigate([PAYMENT_REQUEST], {
            queryParams: { policy: params.get("policy") },
          });
        }

        this.hasUnpaidReceipts = data.debtDetails.hasUnpaidReceipts;
        this.suspensionDate = DateTime.fromJSDate(new Date(data.debtDetails.suspensionDate)).plus({ days: 1 }).toJSDate();
        this.terminationDate = data.debtDetails.terminationDate;
        this.name = data.debtDetails.memberFullName;
        this.userEmail = data.debtDetails.memberEmail;
        this.productName = data.debtDetails.productName;
        this.numeroContrat = data.debtDetails.reference;
        this.amount = data.debtDetails.amount;
        this.receiptDetails = data.debtDetails.receiptDetails;
        this.feeAmount = 0;
        this.formToken = data.formToken;
        this.firstConnectionUrl = data.debtDetails.firstConnectionUrl;
      })
    );
  }

  paymentEvent(event: boolean) {
    this.paymentSuccess = event;
  }

  showPopup(show: boolean) {
    this.showPopupPayment = show;
    this.cdr.detectChanges();
  }
}
